// A tool's warp in the streamed valley (specs, shots, tours; never the game's own play): the hero put down on the
// ground somewhere far, its chunks loaded at once (colliders, nav tiles, events: the sim tier's cut), and one physics
// step so Rapier's broad phase sees the new colliders before the next sim step moves anything over them (Rapier 0.21
// updates its scene queries only in a step). Without it a warp past the resident chunks drops the hero for a step.
// The step moves dynamic bodies one step outside the sim's own: a tool's teleport is not replayed.
import type { WorldMount } from "./scene";

/** Warp the hero to (x, z) on the ground, facing `yaw` (default as it was), and load what it stands on now. */
export function teleportHero(m: WorldMount, x: number, z: number, yaw?: number): void {
  const r = m.rig();
  const facing = yaw ?? r.hero().yaw;
  r.warpHero(x, m.world.heightAt(x, z) + 0.05, z, facing);
  m.sim().teleported();
  r.collision.step();
  // then on the collider's own surface (the heightfield's triangles sit a little off the smooth height function in a
  // narrow carve, the brook's bed)
  r.warpHero(x, r.terrainAt(x, z), z, facing);
}
